export const checkPasswordLength = (password, length = 8) => {
  try {
    return password.trim().length >= length;
  } catch {
    return false;
  }
};

export const checkPasswordCase = (password) => {
  try {
    return /[a-z]/.test(password) && /[A-Z]/.test(password);
  } catch {
    return false;
  }
};

export const checkPasswordSpecialChar = (password) => {
  try {
    return /[!@#$%^&*(),.?":{}|<>]/.test(password);
  } catch {
    return false;
  }
};

export const validateEmail = (email) => {
  try {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  } catch {
    return false;
  }
};

